import { ActivatedRoute } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import {EventEmitterService} from "../../../service/event-emitter-service";

@Component({
  selector: 'app-view-documento-eletronico',
  templateUrl: './view-documento-eletronico.component.html',
  styleUrls: ['./view-documento-eletronico.component.scss']
})
export class ViewDocumentoEletronicoComponent implements OnInit {
  nodeId;
  constructor(private route: ActivatedRoute) {
      this.route.params.subscribe(params => this.nodeId = params['nodeId']);
      EventEmitterService.get("isPrintPage").emit(true);
   }

  ngOnInit() {
    console.log(this.nodeId);
  }

}



// WEBPACK FOOTER //
// /app/src/app/components/caixa/view-documento-eletronico/view-documento-eletronico.component.ts